import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import useTranslate from '@sprinx/react-globalize/useTranslate';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
var componentSettings = {
  name: 'SxShoppingCartButtonAddToCart'
};
var useStyles = makeStyles(function () {
  return {
    root: {
      width: 120
    }
  };
}, componentSettings);

var _ref3 = /*#__PURE__*/React.createElement(AddShoppingCartIcon, null);

function ButtonAddToCart(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      icon = _ref.icon,
      noIcon = _ref.noIcon,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, ["children", "classes", "className", "icon", "noIcon", "onClick"]);

  var classes = useStyles({
    classes: function (_ref2) {
      var root = _ref2.root;
      return {
        root: root
      };
    }(pClasses || {})
  });
  var t = useTranslate();
  var label = children || t('shoppingCart/actions/buy');
  return /*#__PURE__*/React.createElement(Button, _extends({
    className: clsx(classes.root, className),
    startIcon: noIcon ? undefined : icon || _ref3,
    onClick: onClick
  }, rest), label);
}

process.env.NODE_ENV !== "production" ? ButtonAddToCart.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape({
    root: PropTypes.string
  }),
  className: PropTypes.string,
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
  icon: PropTypes.node,
  noIcon: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  variant: PropTypes.oneOf(['text', 'outlined', 'contained'])
} : void 0;
ButtonAddToCart.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined,
  color: 'primary',
  icon: undefined,
  noIcon: false,
  onClick: undefined,
  size: undefined,
  variant: 'contained'
};
export default withThemeProps(withThemeProps)(ButtonAddToCart);